import * as Yup from 'yup';

export const EditOrganisationSchema = Yup.object().shape({
  orgName: Yup.string().label('Organisation name').min(3).max(255).required(),
  orgGroup: Yup.number().label('Organisation group').required(),
  masterAdmin: Yup.number().label('Master administrator').required(),
  hasCreateEnquiry: Yup.boolean(),
  teamLimits: Yup.number().label('Number of teams').max(500).integer(),
  userLimits: Yup.number().label('Number of users').max(500).integer(),
  subscriptionStart: Yup.string().label('Subscription start date').optional(),
  subscriptionEnd: Yup.string().label('Subscription end date').optional(),
  contractRenewal: Yup.string().label('Contract renewal date').optional()
});
